import { useScroll, useTransform, AnimatePresence, useMotionValueEvent } from "framer-motion";
import { motion } from "framer-motion";
import { useState, useEffect, useRef } from "react";
import Loading from "./loading/Loading";

import './App.css';
import './Shared.css';
import CustomScrollbar from './customScrollbar/CustomScrollbar';
import Header from './header/Header';
import Content from './content/Content';
import Projects from './projects/Projects';
import Ticker from './tickerLine/Ticker';
import About from './about/About';
import Contact from './contact/Contact';
import Footer from './footer/Footer';
import Skills from "./skills/Skills";

function App() {
  const [loading, setLoading] = useState(true);

  const scrollRef = useRef(null);
  const { scrollY } = useScroll({ container: scrollRef });
  const scrollForward = useTransform(scrollY, v => v - 1000);
  const scrollReverse = useTransform(scrollY, v => -v - 1000);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const lines = [
    { text: "Emanuel Soares", reverse: false },
    { text: "DEVELOPER", reverse: true },
    { text: "PORTFOLIO", reverse: false },
  ];


  const [showScrollTop, setShowScrollTop] = useState(false);

  useMotionValueEvent(scrollY, "change", (latest) => {
    console.log("scrollY:", latest);
    setShowScrollTop(latest > window.innerHeight);
  });

  return (
    <>
      <AnimatePresence>
        {loading && <Loading />}
      </AnimatePresence>

      {!loading && (
        <>
          <CustomScrollbar ref={scrollRef}>
            <div>
              <section
                className="App"
                style={{ position: 'relative', minHeight: '100vh', overflow: 'visible' }}
              >
                <Header />
                <Content id="top" />

                <div className="ticker-container" style={{ margin: '3rem 0rem' }}>
                  {lines.map((line, index) => (
                    <Ticker
                      key={line.text}
                      className={`ticker-${index}`}
                      items={[
                        <span className="text-solid">{line.text}</span>,
                        <span className="text-outline">{line.text}</span>,
                      ]}
                      offset={line.reverse ? scrollReverse : scrollForward}
                    />
                  ))}
                </div>

                <About id="about" />
                <Skills id="skills" />
                <Projects id="projects" />
                <Contact id="contact" />
              </section>

              <Footer />
            </div>
          </CustomScrollbar>

          <AnimatePresence>
            {showScrollTop && (
              <motion.button
                  onClick={() => document.getElementById("top").scrollIntoView({ behavior: "smooth" })}
                  className="scroll-top-btn"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 10 }}
                  transition={{ duration: 0.3 }}
                >
                  ↑
                </motion.button>
            )}
          </AnimatePresence>
        </>
      )}
    </>
  );
}

export default App;